module.exports = __webpack_public_path__ + "assets/e43d94da955c31cb07443d0fea6e4227.jpg";